<template>

<div 
    class="item" 
    :class="{
        'is-condensed': isCondensed,
        'is-selected': isSelected,
        'is-sticky': isSticky
    }"
    :style="style"
    v-height-watch="{ enabled: isWatchingHeight, onChange: onHeightChange }"
>

    <div 
        class="item-content"
        :style="{gridTemplateColumns: gridFinal}"
    >

        <div />

        <component 
            :is="fieldComponent(field)" 
            :item="item" 
            :field="field" 
            :filter="filter" 
            :key="field.id" 
            :is-condensed="isCondensed"
            v-for="field in fields" 
        />

        <core-list-cell-actions 
            :item="item" 
            :filter="filter" 
            :can="can" 
            :condensed="isCondensed" 
            :horizontal="true"
            v-if="hasActions" 
        />

        <div v-if="!isSticky" />

    </div>

    <app-view-sheet-item-nested :item="item" :fields="fields" :filter="filter" :is-sticky="isSticky" :grid="grid" />
    <app-view-sheet-item-contained :item="item" :fields="fields" :filter="filter" :is-sticky="isSticky" :grid="grid" />

    <slot></slot>

</div>

</template>

<script>

export default {

	props: ['item', 'fields', 'filter', 'grid', 'can', 'isCondensed', 'isSticky'],

    computed: {

        style: function() {

            var style = {}

            if (this.stickyHeight) {

                style.height = this.stickyHeight + 'px'

            }

            return style 

        },

        isWatchingHeight: function() {

            return !this.isSticky && !this.isCondensed

        },

        isSelected: function() {

			return this.$store.getters['service/select'](this.item.id)

		},

        hasActions: function() {

            return this.$route.meta.hasActions && !this.isSticky

        },

        gridFinal: function() {

            if (this.isSticky) {

                return (this.$isDesktop) ? '38px ' + this.grid : '8px ' + this.grid

            } else {

                return (this.$isDesktop) ? '38px ' + this.grid + ' auto 38px' : '8px ' + this.grid + ' auto 8px'

            }

        }

    },

    methods: {

        onHeightChange: function(e) {

            this.$emit('height', e.height)

        },

        fieldComponent: function(field) {

            var component = ['app', 'view', 'sheet', 'field']

            component.push(field.type.replace('.', '_'))

            return component.join('-')

        }

    }

}

</script>

<style scoped>

.item {
	border-bottom: 1px solid #eee;
    position: relative;
}

.item:not(.is-sticky) {
    display: inline-grid;
    min-width: 100%;
}

.item.is-condensed,
.item:last-child {
	border-bottom: 0px;
}

.item.is-selected {
	background-color: #d4f2ff;
}

.is-desktop .item:not(.is-selected):hover {
	background-color: #e9f3f7;
}

.is-desktop .item:not(.is-selected).is-condensed:hover {
	background-color: rgba(0, 0, 0, 0.1);
}

.is-desktop .item.is-selected:hover {
	background-color: #c6e5f3;
}

.item-content {
    display: grid;
    min-height: 40px;
    grid-gap: 0px;
    padding: 0px 0px;
    align-items: flex-start;
}

.is-sticky .item-content {
    padding: 0px 0px;
}

.item.is-condensed .item-content {
    height: 40px;
}

.item:last-child .item-content {
	border-bottom: 0px;
}

</style>